import { BRANDS } from '../consts';

export const isOpusBrand = process.env.REACT_APP_BRAND === BRANDS.OPUS;
export const isDraxBrand = process.env.REACT_APP_BRAND === BRANDS.DRAX;
export const isDev = process.env.REACT_APP_ENV_NAME === 'dev';

export const PHONE_PATTERN = /^\d{11}$/;
export const EMAIL_PATTERN = /^\S+@\S+\.\S+$/;
